import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect based on role only if not already on correct path
  // Admins can access /admin, /donateur, and /orphelin routes
  // Operateurs can access /operateur, /donateur, and /orphelin routes
  const currentPath = window.location.pathname;
  if (user && user.role === 'admin') {
    // Admin can access admin, donateur, and orphelin routes
    if (!currentPath.startsWith('/admin') && 
        !currentPath.startsWith('/donateur') && 
        !currentPath.startsWith('/orphelin')) {
      return <Navigate to="/admin" replace />;
    }
  }
  if (user && user.role === 'operateur') {
    // Operateur can access operateur, donateur, and orphelin routes
    if (!currentPath.startsWith('/operateur') && 
        !currentPath.startsWith('/donateur') && 
        !currentPath.startsWith('/orphelin')) {
      return <Navigate to="/operateur" replace />;
    }
  }
  if (user && user.role === 'maitresse' && !currentPath.startsWith('/maitresse')) {
    return <Navigate to="/maitresse" replace />;
  }
  if (user && user.role === 'donateur' && !currentPath.startsWith('/donateur')) {
    return <Navigate to="/donateur" replace />;
  }

  return children;
};

export default PrivateRoute;



